export function parseCompensationInput(value) {
    const text = String(value || "").trim();
    if (!text || text.length > 1000) return null;
    if (/^\d+(?:[.,]\d{1,2})?$/.test(text)) {
        const salary = Number(text.replace(",", "."));
        return salary > 0 && salary <= 9999999999.99 ? { salary, salary_terms: null } : null;
    }
    return { salary: null, salary_terms: text };
}

export function formatCompensation(value) {
    if (value?.salary_terms) return value.salary_terms;
    return value?.salary != null ? `${Number(value.salary).toLocaleString("ru-RU")} ₽` : "Не указана";
}
